export default {"src":"/_next/static/media/Colorectal-Cancer.c7207b57.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};